import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Grid,
    InputAdornment,
    Stack,
    TextField,
} from "@mui/material";

import CalculateIcon from "@mui/icons-material/Calculate";
import { INPUT_VALIDATION } from "../../../constants";
import { realFocalLengthFromFocalLength35 } from "../../utils/sopCalculation";
import { roundNumber } from "../../utils/roundNumber";
import { useForm } from "react-hook-form";
import { useState } from "react";

export function SensorSimulatorRealFocalLengthFrom35Eqv() {
    const [realFocalLength, setRealFocalLength] = useState(null);

    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm({
        defaultValues: {
            sensorWidth: null,
            sensorHeight: null,
            focalLength35mmEqv: null,
        },
    });

    const onSubmit = (payload) => {
        const realFocalLengthResult = realFocalLengthFromFocalLength35(
            payload.sensorWidth,
            payload.sensorHeight,
            payload.focalLength35mmEqv
        );

        setRealFocalLength(roundNumber(realFocalLengthResult, 1));
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Card>
                <CardHeader title="Real Focal Length (from its 35mm equivalent)" />

                <CardContent>
                    <Grid container spacing={2}>
                        <Grid size={2}>
                            <TextField
                                id="sensorWidth"
                                fullWidth
                                type="number"
                                label="Sensor width"
                                error={Boolean(errors.sensorWidth)}
                                helperText={errors.sensorWidth?.message}
                                {...register("sensorWidth", {
                                    required: INPUT_VALIDATION.REQUIRED_SHORT,
                                    valueAsNumber: true,
                                    validate: (value) =>
                                        value > 0 || INPUT_VALIDATION.POSITIVE,
                                })}
                                inputProps={{
                                    step: "0.01",
                                    inputMode: "decimal",
                                }}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            mm
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField
                                id="sensorHeight"
                                fullWidth
                                type="number"
                                label="Sensor height"
                                error={Boolean(errors.sensorHeight)}
                                helperText={errors.sensorHeight?.message}
                                {...register("sensorHeight", {
                                    required: INPUT_VALIDATION.REQUIRED_SHORT,
                                    valueAsNumber: true,
                                    validate: (value) =>
                                        value > 0 || INPUT_VALIDATION.POSITIVE,
                                })}
                                inputProps={{
                                    step: "0.01",
                                    inputMode: "decimal",
                                }}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            mm
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid size={2}>
                            <TextField
                                id="focalLength35mmEqv"
                                fullWidth
                                type="number"
                                label="35mm Equivalent"
                                error={Boolean(errors.focalLength35mmEqv)}
                                helperText={errors.focalLength35mmEqv?.message}
                                {...register("focalLength35mmEqv", {
                                    required: INPUT_VALIDATION.REQUIRED_SHORT,
                                    valueAsNumber: true,
                                    validate: (value) =>
                                        value > 0 || INPUT_VALIDATION.POSITIVE,
                                })}
                                inputProps={{
                                    step: "0.01",
                                    inputMode: "decimal",
                                }}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            mm
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <Stack direction="row" justifyContent="flex-end">
                                <Button
                                    variant="contained"
                                    startIcon={<CalculateIcon />}
                                    type="submit"
                                >
                                    Compute
                                </Button>
                            </Stack>
                        </Grid>

                        <Grid size={2}>
                            <TextField
                                id="result"
                                fullWidth
                                type="text"
                                label="Result"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                InputProps={{
                                    readOnly: true,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            mm
                                        </InputAdornment>
                                    ),
                                }}
                                value={realFocalLength ?? ""}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </form>
    );
}
